import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function BUTTON__image_a_clear() {
  const dispatch = use_dispatch();

  const { grid2d_image_compare__image_a } = use_slice_ui(['grid2d_image_compare__image_a']);
  /*
   *
   */
  function onClick() {
    dispatch(LOCAL__ui_set_image({ key: 'grid2d_image_compare__image_a', value: DTO__image_asset.CREATE_STUB() }));
  }

  /*
   *
   */
  function is_disabled() {
    return grid2d_image_compare__image_a.is_stub();
  }
  /*
   *
   */

  return (
    <UI_PRIMITIVE__button
      disabled={is_disabled()}
      {...{ onClick }}
      className={` relative h-6  text-component-foreground text-xs w-full`}
      variant="outline-on-component"
    >
      Clear Image A
    </UI_PRIMITIVE__button>
  );
}
